import { forwardRef } from 'react'

const Input = forwardRef(({ className, ...props }, ref) => (
    <input
        ref={ref}
        className={`${className} input`}
        {...props}
    />
))

Input.displayName = 'Input'

export default Input
